import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { LocalityNameViewControllerDelegate, LocalityNameViewController } from "../../Screen/LocalityName/LocalityNameViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { LocalityNameViewModel } from '../../Screen/LocalityName/LocalityNameViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class LocalityNameCoordinator implements IndexCoordinatorDelegate, LocalityNameViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepnomelocalidade")
        return (<ProtectedRoute requiredPermissions={['dengue.nome_localidade.*']} path="/:base/dengue/nome-localidade" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.nome_localidade.adicionar',
                    edit: 'dengue.nome_localidade.editar',
                    delete: 'dengue.nome_localidade.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Nome Localidade"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new LocalityNameViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.nome_localidade.adicionar', 'dengue.nome_localidade.editar']} path="/:base/dengue/nome-localidade/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<LocalityNameViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepnomelocalidade") {
            navigation.history.push(`nome-localidade/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepnomelocalidade") {
            navigation.history.push(`nome-localidade/cad/${idSelection}`);
            return;
        }
    }

}